"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "cartosio": {
    "c72d095a": [{
      "hkey": "c48077b6",
      "slug": "cartosio",
      "name": "Cartosio",
      "primary": true,
      "skipSearch": false
    }],
    "arbiglia": [{
      "hkey": "c48077b6",
      "slug": "cartosio",
      "name": "Cartosio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e252a0fa": [{
      "hkey": "c48077b6",
      "slug": "cartosio",
      "name": "Cartosio",
      "primary": true,
      "skipSearch": false
    }],
    "bernardi": [{
      "hkey": "c48077b6",
      "slug": "cartosio",
      "name": "Cartosio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "24aab413": [{
      "hkey": "c48077b6",
      "slug": "cartosio",
      "name": "Cartosio",
      "primary": true,
      "skipSearch": false
    }],
    "cianella": [{
      "hkey": "c48077b6",
      "slug": "cartosio",
      "name": "Cartosio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9de02b6f": [{
      "hkey": "21dcb810",
      "slug": "colombara",
      "name": "Colombara",
      "primary": true,
      "skipSearch": false
    }],
    "colombaia": [{
      "hkey": "21dcb810",
      "slug": "colombara",
      "name": "Colombara",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "0dfe3d26": [{
      "hkey": "c48077b6",
      "slug": "cartosio",
      "name": "Cartosio",
      "primary": true,
      "skipSearch": false
    }],
    "dianiglia": [{
      "hkey": "c48077b6",
      "slug": "cartosio",
      "name": "Cartosio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "038dbb1a": [{
      "hkey": "c48077b6",
      "slug": "cartosio",
      "name": "Cartosio",
      "primary": true,
      "skipSearch": false
    }],
    "ponte": [{
      "hkey": "c48077b6",
      "slug": "cartosio",
      "name": "Cartosio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "bf3abb4c": [{
      "hkey": "c48077b6",
      "slug": "cartosio",
      "name": "Cartosio",
      "primary": true,
      "skipSearch": false
    }],
    "rossi": [{
      "hkey": "c48077b6",
      "slug": "cartosio",
      "name": "Cartosio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a2cb7126": [{
      "hkey": "c48077b6",
      "slug": "cartosio",
      "name": "Cartosio",
      "primary": true,
      "skipSearch": false
    }],
    "san-martino": [{
      "hkey": "c48077b6",
      "slug": "cartosio",
      "name": "Cartosio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c93db293": [{
      "hkey": "c48077b6",
      "slug": "cartosio",
      "name": "Cartosio",
      "primary": true,
      "skipSearch": false
    }],
    "valcardosa": [{
      "hkey": "c48077b6",
      "slug": "cartosio",
      "name": "Cartosio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0803bcf1": [{
      "hkey": "c48077b6",
      "slug": "cartosio",
      "name": "Cartosio",
      "primary": true,
      "skipSearch": false
    }],
    "viotti": [{
      "hkey": "c48077b6",
      "slug": "cartosio",
      "name": "Cartosio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;